/* eslint-disable react-hooks/exhaustive-deps */
import { FC, useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { ROUTES } from "../../../utils/routes";
import Axios from "axios";
import { getAll, getById } from "../../../utils/requests/dynamicReq";
import { paths } from "../../../utils/paths";

import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Col, Form, InputGroup } from "react-bootstrap";
import { useSelector } from "react-redux";
import { IStore } from "../../../interfaces/IStore";
import { IUser } from "../../../interfaces/IUser";

interface IAmbitoShort {
  id: string;
  tituloEs: string;
}

export const Ambitos: FC = () => {
  const history = useHistory();

  let { staffId, isAdmin, userRoleId } = useSelector(({ user }: IStore) => user as IUser);  

  const [isLoading, setIsLoading] = useState(false);

  const isMountedRef = useRef(false);
  const source = Axios.CancelToken.source();
  const { AMBITOS, INVESTIGATORS } = paths;
  const [ambitos, setAmbitos] = useState<any>([]);
  const [search, setSearch] = useState("");
  const [filteredAmbitos, setFilteredAmbitos] = useState<IAmbitoShort[]>([]);

  useEffect(() => {
    setIsLoading(true);
    isMountedRef.current = true;
    try {
      isMountedRef.current && loadAmbitos();
    } catch (error) {
      console.log(error);
      console.log("HTTP call cancelled");
    }
    return () => {
      isMountedRef.current = false;
      source.cancel();
    };
  }, []);

  const loadAmbitos = async () => {
    try {
      if (isAdmin) {
        const response = await getAll(AMBITOS, source);
        if (isMountedRef.current) {
          filterAmbitos(response);
        }
      } else if (!isAdmin) {
        let id = staffId.toString();
        const investigator = await getById(INVESTIGATORS, id, source);
        if (isMountedRef.current) {
          filterAmbitoByInvestigator(investigator);
        }
      }
      setIsLoading(false);
    } catch (error) {
      console.log("HTTP call cancelled");
    }
  };

  const filterAmbitos = (rawAmbitos: any[]) => {
    let ambitos: IAmbitoShort[] = rawAmbitos.map(
      ({ id, tituloEs }: IAmbitoShort) => ({
        id,
        tituloEs,
      })
    );
    setAmbitos(ambitos);
    setFilteredAmbitos(ambitos);
  };

  const filterAmbitoByInvestigator = (rawAmbitos: any) => {
    // console.log(rawGroups.investigationGroup);
    if (!!rawAmbitos.investigationGroup) {
      let ambitos: IAmbitoShort[] = [
        {
          id: rawAmbitos?.investigationGroup?.id,
          tituloEs: rawAmbitos?.investigationGroup?.tituloEs,
        },
      ];
      setAmbitos(ambitos);
      setFilteredAmbitos(ambitos);
    }
  };

  const handleSearch = (value: any) => {
    setSearch(value);
    setFilteredAmbitos(
      ambitos.filter(({ tituloEs }: any) =>
        tituloEs.toLowerCase().includes(value.toLowerCase())
      )
    );
    !value && setFilteredAmbitos(ambitos);
  };

  return (
    <div className="container-fluid p-4">
      {!isAdmin && userRoleId !== 3 ? (
        <>Usted no tiene acceso</>
      ) : (
        <>
          {" "}
          <div className="row">
            <div className="col-12 d-flex justify-content-between">
              <h3>Ámbitos</h3>
              <div>
                {(isAdmin || userRoleId === 3) && (
                  <button
                    className="baseBtn"
                    onClick={() => history.push(`${ROUTES.Ambitos.create}`)}
                  >
                    + Añadir
                  </button>
                )}
              </div>
            </div>
          </div>
          {/* <div className="center flex-column justify-content-around text-center p-5 mt-2"> */}
          <div className="row mt-4">
            <Form.Group as={Col}>
              <InputGroup className="shadow">
                <InputGroup.Prepend>
                  <InputGroup.Text className="inputGroup ">
                    <FontAwesomeIcon color="#0073B5" icon={faSearch} />
                  </InputGroup.Text>
                </InputGroup.Prepend>
                <Form.Control
                  type="text"
                  placeholder="Buscar..."
                  className="form-control"
                  value={search}
                  onChange={(e) => handleSearch(e.target.value)}
                />
              </InputGroup>
            </Form.Group>
          </div>
          <div className="row">
            <div className="col-12 ">
              <table className="table table-hover">
                <tbody>
                  {filteredAmbitos?.map(
                    ({ id, tituloEs }: IAmbitoShort, index: number) => (
                      <tr
                        key={index}
                        className="pointer"
                        onClick={() =>
                          history.push(`${ROUTES.Ambitos.all}/${id}`)
                        }
                      >
                        <td>{`${tituloEs}`}</td>
                      </tr>
                    )
                  )}
                </tbody>
              </table>
              {isLoading && (
                <div className="d-flex justify-content-center">
                  <div className="spinner-border mt-5" role="status" />
                </div>
              )}

              {!filteredAmbitos.length && !isLoading && isAdmin && (
                <div className="d-flex justify-content-center mb-3">
                  <h5>-No existen ámbitos-</h5>
                </div>
              )}

              {/* {!filteredAmbitos.length && !isLoading && !isAdmin && (
                <div className="d-flex justify-content-center mb-3">
                  <h5>-No pertenece a ningún grupo-</h5>
                </div>
              )} */}
            </div>
          </div>
        </>
      )}
    </div>
    // </div>
  );
};
